import { useSelector } from "react-redux";

function QuestionCard({ TextValue, handleAnswerSelect, selectedOption }) {
  const contentValue = useSelector((state) => state.contents.contentValues);

  let currentQuestion;
  let correctAnswer;

  if (contentValue.section === "vocabulary") {
    currentQuestion = contentValue?.contents?.[TextValue];
    correctAnswer = currentQuestion?.Eng;
  } else if (contentValue.section === "reading") {
    currentQuestion = contentValue?.Questions?.[TextValue];
    correctAnswer = currentQuestion?.answer;
  }

  return (
    <div
      className={`bg-white border-yellow-400 border-l-6  
          rounded-2xl p-4 md:p-6 shadow-xl hover:shadow-2xl transition-all w-full md:w-auto
        `}
    >
      {/* Reading modunda soru başlığını göster */}
      {contentValue?.section === "reading" && currentQuestion.question && (
        <h3
          className="px-3 py-1 bg-purple-100 font-semibold rounded-lg
           text-md md:text-lg mb-4 text-purple-700"
        >
          {currentQuestion.question}
        </h3>
      )}
      <div className="space-y-2">
        {currentQuestion.options.map((option, optionIndex) => {
          // Bu seçenek doğru cevap mı?
          const isCorrectOption = option === correctAnswer;
          // Kullanıcı bu seçeneği seçti mi?
          const isSelected = selectedOption === option;

          return (
            <button
              key={optionIndex}
              onClick={() => handleAnswerSelect(option)}
              disabled={selectedOption !== undefined} // Bu soru için seçim yapıldıysa kilitle
              className={`
                w-full text-left px-2 md:px-4 py-1 md:py-3 rounded-lg text-md md:text-lg
                transition-all duration-200
                ${
                  selectedOption === undefined
                    ? "bg-gray-50 hover:bg-purple-50 hover:border-purple-300 border-2 border-gray-200 cursor-pointer"
                    : isSelected && isCorrectOption
                      ? "bg-green-200 border-2 border-green-500 text-green-800"
                      : isSelected && !isCorrectOption
                        ? "bg-red-200 border-2 border-red-500 text-red-800"
                        : isCorrectOption
                          ? "bg-green-50 border-2 border-green-400 text-green-700"
                          : "bg-gray-100 border-2 border-gray-300 text-gray-500"
                }
                ${
                  selectedOption !== undefined
                    ? "cursor-not-allowed"
                    : "cursor-pointer"
                }
              `}
            >
              <div className="flex items-center justify-between">
                <span className="font-normal text-sm md:text-xl">{option}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default QuestionCard;
